import React, { Component } from "react";
import Axios from "axios";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import { useStyles } from "./GeneralSetting.css";
import GeneralForm from "./GeneralForm/GeneralForm";
import { CustomLinearProgress } from "../../../Components/CustomLinearProgress/CustomLinearProgress";
import { url } from "../../../Config/Config";
import { publicImageUrl } from "../../../Config/publicImageUrl";
import AdminHeader from "../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import InfoDetails from "./InfoDetails/InfoDetails";
import { getAdminRefreshToken } from "../../../Redux/Actions/actions";
import FormLoader from "../../../Components/FormLoader/FormLoader";

class GeneralSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        schoolName: "",
        shortName: "",
        address: "",
        mobileNumber: "",
        altMobileNumber: "",
        landLineNumber: "",
        altLandLineNumber: "",
        schoolLogo: "",
        email: "",
        altEmail: "",
        fbLink: "",
        instaLink: "",
        twitterLink: "",
        youtubeLink: "",
      },
      schoolLogoFiles: [],
      schoolLogoUrl: "",
      schoolLogoLoading: false,
      schoolLogoPercentage: 0,
      schoolLogoError: "",
      editStatus: false,
      imageToDelete: "",
      deleteImage: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.getSchoolInfo();
  }

  getSchoolInfo = async () => {
    const response = await Axios.get(`${url}/api/setting`, {
      headers: { Authorization: `Bearer ${this.props.adminToken}` },
    });
    if (response.data._id) {
      this.setState({
        data: {
          schoolName: response.data.schoolName,
          shortName: response.data.shortName,
          address: response.data.address,
          mobileNumber: response.data.mobileNumber,
          altMobileNumber: response.data.altMobileNumber
            ? response.data.altMobileNumber
            : "",
          landLineNumber: response.data.landLineNumber,
          altLandLineNumber: response.data.altLandLineNumber
            ? response.data.altLandLineNumber
            : "",
          schoolLogo: response.data.schoolLogo,
          email: response.data.email,
          altEmail: response.data.altEmail ? response.data.altEmail : "",
          fbLink: response.data.fbLink ? response.data.fbLink : "",
          instaLink: response.data.instaLink ? response.data.instaLink : "",
          twitterLink: response.data.twitterLink
            ? response.data.twitterLink
            : "",
          youtubeLink: response.data.youtubeLink
            ? response.data.youtubeLink
            : "",
        },
        imageToDelete: response.data.schoolLogo,
      });
    }
  };

  handleEdit = (editStatus) => {
    this.setState({
      editStatus,
    });
  };

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  handleSchoolLogo = async (e) => {
    if (this.state.imageToDelete) {
      this.setState({
        deleteImage: true,
      });
    }
    let reader = new FileReader();
    let files = e.target.files[0];
    this.setState({
      schoolLogoFiles: files,
      schoolLogoLoading: true,
    });

    reader.onload = () => {
      this.setState({
        schoolLogoUrl: window.URL.createObjectURL(e.target.files[0]),
      });
    };

    reader.onprogress = (data) => {
      this.setState({
        schoolLogoLoading: false,
      });
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          schoolLogoPercentage: progress,
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleSchoolLogoProgress = () =>
    this.state.schoolLogoPercentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.schoolLogoPercentage}
          variant="determinate"
        />
        {this.state.schoolLogoPercentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.schoolLogoPercentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  uploadImage = async (files) => {
    const {
      data: { signedUrl, key },
    } = await Axios.post(`${url}/api/uploads`, {
      dir: "SchoolInfo",
      contentType: files.type,
    });
    await Axios.put(signedUrl, files, {
      headers: {
        "content-type": files.type,
      },
    });
    await Axios.post(`${url}/api/uploads/public`, {
      fileName: key,
    });

    return key;
  };

  filterData = (data) => {
    let changedData = data;
    if (!data.altLandLineNumber) {
      delete changedData.altLandLineNumber;
    }
    if (!data.altMobileNumber) {
      delete changedData.altMobileNumber;
    }
    if (!data.altEmail) {
      delete changedData.altEmail;
    }
    if (!data.fbLink) {
      delete changedData.fbLink;
    }
    if (!data.instaLink) {
      delete changedData.instaLink;
    }
    if (!data.twitterLink) {
      delete changedData.twitterLink;
    }
    if (!data.youtubeLink) {
      delete changedData.youtubeLink;
    }

    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      let changedData = this.filterData(this.state.data);
      let data;
      if (this.state.deleteImage === false) {
        data = { ...changedData, schoolLogo: this.state.imageToDelete };
      } else {
        let imageKey = await this.uploadImage(this.state.schoolLogoFiles);
        data = { ...changedData, schoolLogo: imageKey };
      }
      const response = await Axios.post(`${url}/api/setting`, data, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (this.state.deleteImage) {
        await Axios.post(
          `${url}/api/uploads/delete/`,
          {
            fileName: this.state.imageToDelete,
          },
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
      }
      if (response.data.message === "Setting added successfully") {
        this.setState({ loading: false });
        this.handleEdit(false);
      }
    } catch (error) {
      this.setState({ loading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div style={{ fontSize: 24 }}>General Setting</div>
          {this.state.editStatus ? (
            <>
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                Edit Information
              </div>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    container
                    spacing={3}
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    lg={12}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div>School Logo</div>
                    <div>
                      {this.state.schoolLogoUrl ? (
                        <img
                          src={`${this.state.schoolLogoUrl}`}
                          alt={this.state.data.schoolName}
                          style={{ width: 100, height: 100 }}
                        />
                      ) : (
                        this.state.data.schoolLogo && (
                          <img
                            src={`${publicImageUrl}/${this.state.data.schoolLogo}`}
                            alt={this.state.data.schoolName}
                            style={{ width: 100, height: 100 }}
                          />
                        )
                      )}
                    </div>
                    <div>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={this.handleSchoolLogo}
                      />
                      <div>
                        <div style={{ padding: 10 }}>
                          {this.handleSchoolLogoProgress()}
                        </div>
                        <div>
                          {this.state.schoolLogoLoading === true && (
                            <CircularProgress />
                          )}
                        </div>
                      </div>
                      <div style={{ color: "red", fontWeight: "bold" }}>
                        {this.state.schoolLogoError}
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                    <GeneralForm
                      data={this.state.data}
                      handleChange={this.handleChange}
                    />
                  </Grid>
                </Grid>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    type="submit"
                    variant="outlined"
                    className={classes.buttonStyle}
                  >
                    {this.state.editStatus ? "Update" : "Save"}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => this.handleEdit(false)}
                    className={classes.buttonStyle}
                  >
                    Cancel
                  </Button>
                  {this.state.loading && <FormLoader />}
                </div>
              </form>
            </>
          ) : (
            <InfoDetails data={this.state.data} handleEdit={this.handleEdit} />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(GeneralSetting)));
